import React from "react";

import { Form } from "react-bootstrap";

import styles from "../roleManagementModal.module.css";

const RoleManagementModalItem = ({ item, availableActionByChapterId, onUpdateItem }) => {
  const handleOnChange = (value) => {
    onUpdateItem(item, value);
  };

  const itemCheck = () => {
    const isAction = availableActionByChapterId.some((chapter) => {
      return chapter.actionId === item.id && chapter.privValue === true;
    });

    return !!isAction;
  };

  return (
    <div
      className={styles["checkbox-container"]}
      key={item.id}>
      <input
        type="checkbox"
        id={item.id}
        checked={itemCheck()}
        onChange={(e) => handleOnChange(e.target.checked)}
        className={styles["checkbox"]}
      />
      <label className={styles["permission-name"]}>{item.name}</label>
    </div>
  );
};

export default RoleManagementModalItem;
